/* Sample-kit controls. Cart forms, FAQs and native video retain native fallbacks. */
(function () {
  'use strict';
  if (window.__fizzySampleSplash) return;
  window.__fizzySampleSplash = true;

  var instances = new Map();
  var popupAttempts = new Map();
  var addingKit = false;
  var evaluationsReady;

  // Reuse FrontrowMD's own review modal; load it only when an evaluation is requested.
  function loadEvaluations() {
    if (evaluationsReady) return evaluationsReady;
    var origin = 'https://app.thefrontrowhealth.com';
    evaluationsReady = new Promise(function (resolve, reject) {
      var selector = 'iframe.iframe-modal-testimonials';
      var script = document.querySelector('script[src="' + origin + '/api/widgets/script?presentation_type=qual&product_id=2584"]');
      var timer;
      function finish(error) {
        window.clearTimeout(timer);
        document.removeEventListener('load', onFrameLoad, true);
        if (script) {
          script.removeEventListener('load', onScriptLoad);
          script.removeEventListener('error', onScriptError);
        }
        if (error) reject(error);
        else resolve(document.querySelector(selector));
      }
      function onFrameLoad(event) {
        if (!event.target.matches || !event.target.matches(selector)) return;
        event.target.dataset.fskLoaded = 'true';
        if (typeof window.openTestimonialsModal === 'function') finish();
      }
      function onScriptLoad() {
        var frame = document.querySelector(selector);
        if (!frame || typeof window.openTestimonialsModal !== 'function') {
          finish(new Error('FrontrowMD reviews are unavailable.'));
        } else if (frame.dataset.fskLoaded === 'true') finish();
      }
      function onScriptError() {
        script.remove();
        finish(new Error('FrontrowMD reviews could not load.'));
      }
      var existing = document.querySelector(selector);
      if (existing && typeof window.openTestimonialsModal === 'function') {
        // Another FrontrowMD section may already own the loaded modal.
        resolve(existing);
        return;
      }
      document.addEventListener('load', onFrameLoad, true);
      timer = window.setTimeout(function () { finish(new Error('FrontrowMD reviews took too long to load.')); }, 15000);
      if (!script) {
        script = document.createElement('script');
        script.src = origin + '/api/widgets/script?presentation_type=qual&product_id=2584';
        script.defer = true;
        script.addEventListener('load', onScriptLoad);
        script.addEventListener('error', onScriptError);
        document.head.appendChild(script);
      } else {
        script.addEventListener('load', onScriptLoad);
        script.addEventListener('error', onScriptError);
      }
    }).catch(function (error) {
      evaluationsReady = null;
      throw error;
    });
    return evaluationsReady;
  }

  function initEvaluations(root) {
    var status = root.querySelector('[data-fsk-evaluation-status]');
    var fallback = root.querySelector('[data-fsk-evaluation-fallback]');
    var trigger;
    var modal;
    var disposed = false;
    var focusFrame;
    function selectPendingReview() {
      modal.dataset.fskLoaded = 'true';
      if (!disposed && modal.style.display !== 'none') {
        modal.contentWindow.postMessage({ name: 'SCROLL_TO_REVIEW', value: trigger.dataset.fskEvaluation }, 'https://app.thefrontrowhealth.com');
      }
    }
    function onClick(event) {
      var button = event.target.closest('[data-fsk-evaluation]');
      if (!button || button.disabled) return;
      trigger = button;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      fallback.hidden = true;
      status.hidden = false;
      status.textContent = 'Loading evaluation…';
      var reviewId = button.dataset.fskEvaluation;
      loadEvaluations().then(function (frame) {
        if (disposed) return;
        modal = frame;
        status.hidden = true;
        window.openTestimonialsModal(reviewId, 'sample_clinician_carousel');
        // Re-select after a pending iframe load when reusing an existing integration.
        if (frame.dataset.fskLoaded !== 'true') frame.addEventListener('load', selectPendingReview, { once: true });
      }).catch(function () {
        if (disposed) return;
        status.textContent = 'The evaluation couldn’t load. Please try again.';
        fallback.href = 'https://app.thefrontrowhealth.com/api/widgets/testimonials?presentation_type=qual&product_id=2584#note-' + encodeURIComponent(reviewId);
        fallback.hidden = false;
      }).finally(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
    }
    function onClose(event) {
      if (event.origin !== 'https://app.thefrontrowhealth.com' || !modal) return;
      var name = typeof event.data === 'string' ? event.data : event.data && event.data.name;
      if (name !== 'CLOSE_TESTIMONIALS_MODAL' && name !== 'CLOSE_ALL_MODALS') return;
      var provider = document.querySelector('#frontrow-portal iframe.iframe-provider-profile-modal');
      if (event.source !== modal.contentWindow && !(name === 'CLOSE_ALL_MODALS' && provider && event.source === provider.contentWindow)) return;
      // Vendor close handlers also manage focus; restore the native trigger afterwards.
      window.cancelAnimationFrame(focusFrame);
      focusFrame = window.requestAnimationFrame(function () {
        if (!disposed && trigger && trigger.isConnected) trigger.focus({ preventScroll: true });
      });
    }
    root.addEventListener('click', onClick);
    window.addEventListener('message', onClose);
    return function () {
      disposed = true;
      window.cancelAnimationFrame(focusFrame);
      if (modal) modal.removeEventListener('load', selectPendingReview);
      root.removeEventListener('click', onClick);
      window.removeEventListener('message', onClose);
    };
  }

  var lastPopupTrigger = null;
  var lastClosed = new Map();

  function kitFormVisible(id) {
    var el = document.querySelector('[data-testid="klaviyo-form-' + id + '"], [role="dialog"][aria-label="POPUP Form"]');
    return !!(el && el.getClientRects().length && window.getComputedStyle(el).display !== 'none');
  }

  function clearPopupAttempt(form) {
    var attempt = popupAttempts.get(form);
    if (!attempt) return;
    window.clearTimeout(attempt.timer);
    if (attempt) window.clearTimeout(attempt.openTimer);
    attempt.button.disabled = false;
    attempt.button.removeAttribute('aria-busy');
    popupAttempts.delete(form);
  }

  function openKitPopup(form, formId, trigger) {
    if (popupAttempts.has(form)) return;
    var button = trigger || form.querySelector('button[type="submit"], [data-fsk-popup-open]');
    var status = form.querySelector('[data-fsk-cart-status]');
    var fallback = form.querySelector('[data-fsk-popup-recovery]');
    status.textContent = 'Opening email signup…';
    fallback.hidden = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    lastPopupTrigger = { button: button, formId: String(formId) };
    function showRecovery() {
      clearPopupAttempt(form);
      if (!form.isConnected) return;
      if (kitFormVisible(formId)) {
        status.textContent = '';
        return;
      }
      status.textContent = 'Email signup couldn’t open. Try again, or buy the kit without signing up.';
      fallback.hidden = false;
    }
    popupAttempts.set(form, { formId: String(formId), button: button, timer: window.setTimeout(showRecovery, 4500) });
    function requestOpen() {
      try {
        // Queue while vendor JS loads. Let its 350 ms close animation finish before reopening.
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', formId]);
      } catch (error) {
        showRecovery();
      }
    }
    var reopenDelay = Math.max(0, 400 - (Date.now() - (lastClosed.get(String(formId)) || 0)));
    if (reopenDelay) popupAttempts.get(form).openTimer = window.setTimeout(requestOpen, reopenDelay);
    else requestOpen();
  }

  // The vendor's close event can arrive after its exit animation begins.
  document.addEventListener('click', function (event) {
    if (lastPopupTrigger && event.target.closest && event.target.closest('.klaviyo-close-form')) {
      lastClosed.set(lastPopupTrigger.formId, Date.now());
    }
  }, true);

  window.addEventListener('klaviyoForms', function (event) {
    var detail = event.detail || {};
    var id = String(detail.formId || '');
    if (detail.type === 'open') {
      // Also clear a recovery shown before a slow form finally opened.
      document.querySelectorAll('[data-fsk-klaviyo-form]').forEach(function (form) {
        if (form.getAttribute('data-fsk-klaviyo-form') !== id) return;
        clearPopupAttempt(form);
        var fallback = form.querySelector('[data-fsk-popup-recovery]');
        var status = form.querySelector('[data-fsk-cart-status]');
        if (fallback) fallback.hidden = true;
        if (status) status.textContent = '';
      });
    }
    if (detail.type === 'close') lastClosed.set(id, Date.now());
    if (detail.type === 'close' && lastPopupTrigger && lastPopupTrigger.formId === id) {
      var button = lastPopupTrigger.button;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          if (button.isConnected && !button.closest('[inert]')) button.focus({ preventScroll: true });
        });
      });
    }
  });

  // XPCigS owns its purchase/checkout flow. Opening it never also adds a kit.
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-fsk-popup-open]');
    if (!button) return;
    var container = button.closest('[data-fsk-popup]');
    if (!container) return;
    event.preventDefault();
    openKitPopup(container, container.getAttribute('data-fsk-klaviyo-form'), button);
  });

  document.addEventListener('submit', async function (event) {
    var form = event.target.closest && event.target.closest('[data-fsk-cart-form]');
    if (!form) return;
    if (event.submitter && event.submitter.hasAttribute('data-fsk-cart-bypass')) {
      clearPopupAttempt(form);
      // Native POST navigates away so a delayed popup cannot add another kit here.
      return;
    }
    var formId = form.getAttribute('data-fsk-klaviyo-form');
    if (formId) {
      event.preventDefault();
      openKitPopup(form, formId);
      return;
    }
    if (!window.fetch) return;
    event.preventDefault();
    if (addingKit) return;
    addingKit = true;
    var button = form.querySelector('button[type="submit"]');
    var status = form.querySelector('[data-fsk-cart-status]');
    var recovery = form.querySelector('[data-fsk-cart-recovery]');
    var label = button.innerHTML;
    var confirmed = false;
    button.disabled = true;
    button.textContent = 'Adding your kit…';
    status.textContent = '';
    recovery.hidden = true;
    try {
      var response = await fetch(form.action + '.js', {
        method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }
      });
      var result = await response.json();
      if (!response.ok) {
        status.textContent = result.description || result.message || 'The kit could not be added. Please try again.';
        return;
      }
      confirmed = true;
      status.textContent = 'Your one-time sample kit is in the cart.';
      if (window.FizzyCart && typeof window.FizzyCart.refresh === 'function') {
        await window.FizzyCart.refresh();
        window.FizzyCart.open();
      } else {
        window.location.assign(recovery.href);
      }
    } catch (error) {
      // An interrupted response may still have added the item. Never auto-retry.
      status.textContent = confirmed ? 'Your kit was added. Open your cart to continue.' : 'We couldn’t confirm the cart update. Check your cart before trying again.';
      recovery.hidden = false;
    } finally {
      button.disabled = false;
      button.innerHTML = label;
      addingKit = false;
    }
  });

  function initFounderVideo(root) {
    var video = root.querySelector('[data-fsk-founder-video]');
    var button = root.querySelector('[data-fsk-founder-play]');
    var status = root.querySelector('[data-fsk-video-status]');
    if (!video || !button || !status) return function () {};
    var film = video.closest('[data-fsk-video-fade]');
    var caption = film && button.querySelector('small');
    var initialCaption = caption && caption.textContent;
    var initialTabIndex = video.getAttribute('tabindex');
    var disposed = false;
    var request = 0;
    var pending = false;

    function finishLoading() {
      pending = false;
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
      if (caption) caption.textContent = initialCaption;
    }
    function fadePoster(visible, state) {
      // The poster stays painted throughout both transitions; inert only
      // removes the faded control from interaction and the accessibility tree.
      button.hidden = false;
      if (!visible && document.activeElement === button) video.focus({ preventScroll: true });
      button.inert = !visible;
      button.setAttribute('aria-hidden', String(!visible));
      film.dataset.videoState = state;
    }
    function showError() {
      if (disposed) return;
      finishLoading();
      video.controls = true;
      video.tabIndex = initialTabIndex === null ? 0 : Number(initialTabIndex);
      if (film) fadePoster(false, 'error');
      else button.hidden = true;
      status.hidden = false;
    }
    function showPoster() {
      if (disposed || video.error) return;
      var hadVideoFocus = document.activeElement === video;
      request++;
      finishLoading();
      video.controls = false;
      if (film) {
        fadePoster(true, 'paused');
        video.tabIndex = -1;
      } else button.hidden = false;
      if (hadVideoFocus) button.focus({ preventScroll: true });
    }
    function showPlayback() {
      if (disposed || video.paused) return;
      finishLoading();
      status.hidden = true;
      video.controls = true;
      video.tabIndex = initialTabIndex === null ? 0 : Number(initialTabIndex);
      if (film) fadePoster(false, 'playing');
      else button.hidden = true;
    }
    function onPause() {
      // Leave native seeking alone; a real pause restores the same thumbnail.
      if (root.hasAttribute('data-fsk-components') && !video.seeking) showPoster();
    }
    function play() {
      if (pending || disposed) return;
      var attempt = ++request;
      pending = true;
      status.hidden = true;
      if (film) {
        film.dataset.videoState = 'loading';
        button.setAttribute('aria-busy', 'true');
        button.setAttribute('aria-disabled', 'true');
        if (caption) caption.textContent = 'Loading her story…';
      } else {
        button.hidden = true;
        video.controls = true;
        video.focus({ preventScroll: true });
      }
      var playback = video.play();
      if (playback && typeof playback.catch === 'function') playback.catch(function (error) {
        if (disposed || attempt !== request) return;
        if (error.name === 'AbortError') showPoster();
        else showError();
      });
    }

    showPoster();
    button.addEventListener('click', play);
    video.addEventListener('error', showError);
    video.addEventListener(film ? 'playing' : 'play', showPlayback);
    video.addEventListener('pause', onPause);
    video.addEventListener('ended', showPoster);
    return function () {
      disposed = true;
      request++;
      button.removeEventListener('click', play);
      video.removeEventListener('error', showError);
      video.removeEventListener(film ? 'playing' : 'play', showPlayback);
      video.removeEventListener('pause', onPause);
      video.removeEventListener('ended', showPoster);
      video.pause();
      video.controls = true;
      if (initialTabIndex === null) video.removeAttribute('tabindex');
      else video.setAttribute('tabindex', initialTabIndex);
      finishLoading();
      button.inert = false;
      button.removeAttribute('aria-hidden');
      button.hidden = true;
      if (film) delete film.dataset.videoState;
    };
  }

  // A native swipe track mirrors the PDP; images never change the kit contents.
  function initGallery(root) {
    var gallery = root.querySelector('[data-fsk-gallery]');
    if (!gallery) return function () {};
    var track = gallery.querySelector('[data-fsk-gallery-track]');
    var slides = gallery.querySelectorAll('[data-fsk-gallery-slide]');
    var thumbs = gallery.querySelectorAll('[data-fsk-gallery-thumb]');
    var strip = gallery.querySelector('.fsk-gallery__thumbs');
    var counter = gallery.querySelector('[data-fsk-gallery-counter]');
    var prev = gallery.querySelector('[data-fsk-gallery-prev]');
    var next = gallery.querySelector('[data-fsk-gallery-next]');
    if (!track || !slides.length) return function () {};
    var preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    var index = 0;
    var scrollFrame = 0;
    var drag = null;
    var width = track.clientWidth;

    function setActive(value) {
      index = Math.max(0, Math.min(slides.length - 1, value));
      slides.forEach(function (slide, i) { slide.setAttribute('aria-hidden', String(i !== index)); });
      thumbs.forEach(function (thumb, i) { thumb.setAttribute('aria-pressed', String(i === index)); });
      counter.textContent = (index + 1) + ' / ' + slides.length;
      slides[index].querySelector('img').loading = 'eager';
      if (slides[index + 1]) slides[index + 1].querySelector('img').loading = 'eager';
      var active = thumbs[index];
      if (active && strip) {
        var item = active.getBoundingClientRect();
        var bounds = strip.getBoundingClientRect();
        if (item.left < bounds.left + 4) strip.scrollLeft += item.left - bounds.left - 4;
        else if (item.right > bounds.right - 4) strip.scrollLeft += item.right - bounds.right + 4;
      }
    }
    function go(value, instant) {
      var target = ((value % slides.length) + slides.length) % slides.length;
      slides[target].querySelector('img').loading = 'eager';
      track.scrollTo({ left: target * track.clientWidth, behavior: instant || preference.matches ? 'instant' : 'smooth' });
    }
    function onScroll() {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(function () {
        scrollFrame = 0;
        if (!track.clientWidth) return;
        var visible = Math.round(track.scrollLeft / track.clientWidth);
        if (visible !== index) setActive(visible);
      });
    }
    function onClick(event) {
      var thumb = event.target.closest('[data-fsk-gallery-thumb]');
      if (thumb) go(Number(thumb.dataset.index));
      else if (event.target.closest('[data-fsk-gallery-prev]')) go(index - 1);
      else if (event.target.closest('[data-fsk-gallery-next]')) go(index + 1);
    }
    function onKey(event) {
      if (event.key === 'ArrowLeft') go(index - 1);
      else if (event.key === 'ArrowRight') go(index + 1);
      else if (event.key === 'Home') go(0);
      else if (event.key === 'End') go(slides.length - 1);
      else return;
      event.preventDefault();
    }
    function onPointerDown(event) {
      // Touch stays native, preserving vertical page scroll and pinch zoom.
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      drag = { id: event.pointerId, x: event.clientX, left: track.scrollLeft };
      track.setPointerCapture(event.pointerId);
      track.classList.add('is-dragging');
    }
    function onPointerMove(event) {
      if (!drag || event.pointerId !== drag.id) return;
      track.scrollLeft = drag.left - (event.clientX - drag.x);
    }
    function endDrag(event) {
      if (!drag || event.pointerId !== drag.id) return;
      var pointerId = drag.id;
      drag = null;
      track.classList.remove('is-dragging');
      if (track.hasPointerCapture(pointerId)) track.releasePointerCapture(pointerId);
      if (track.clientWidth) go(Math.round(track.scrollLeft / track.clientWidth));
    }
    function onResize() {
      var nextWidth = track.clientWidth;
      if (nextWidth && nextWidth !== width) {
        width = nextWidth;
        go(index, true);
      }
    }
    var resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(onResize) : null;
    if (resizeObserver) resizeObserver.observe(track);
    else window.addEventListener('resize', onResize);
    gallery.addEventListener('click', onClick);
    gallery.addEventListener('keydown', onKey);
    track.addEventListener('scroll', onScroll, { passive: true });
    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('lostpointercapture', endDrag);
    prev.hidden = next.hidden = counter.hidden = false;
    setActive(Math.round(track.scrollLeft / Math.max(width, 1)));
    return function () {
      if (resizeObserver) resizeObserver.disconnect();
      else window.removeEventListener('resize', onResize);
      window.cancelAnimationFrame(scrollFrame);
      gallery.removeEventListener('click', onClick);
      gallery.removeEventListener('keydown', onKey);
      track.removeEventListener('scroll', onScroll);
      track.removeEventListener('pointerdown', onPointerDown);
      track.removeEventListener('pointermove', onPointerMove);
      track.removeEventListener('pointerup', endDrag);
      track.removeEventListener('pointercancel', endDrag);
      track.removeEventListener('lostpointercapture', endDrag);
      if (drag && track.hasPointerCapture(drag.id)) track.releasePointerCapture(drag.id);
      drag = null;
      track.classList.remove('is-dragging');
    };
  }

  function initClinicianBadges(root) {
    var frames = Array.from(root.querySelectorAll('[data-fsk-badge-frame]'));
    if (!frames.length) return function () {};
    var origin = 'https://app.thefrontrowhealth.com';
    var script = document.querySelector('script[data-fsk-quant-loader]');
    function reveal(frame, height) {
      if (!Number.isFinite(height) || height < 20 || height > 200) return;
      frame.style.height = height + 'px';
      frame.parentElement.classList.add('is-ready');
      frame.removeAttribute('tabindex');
      frame.removeAttribute('aria-hidden');
      frame.parentElement.querySelector('[data-fsk-badge-fallback]').hidden = true;
    }
    function ready() {
      frames.forEach(function (frame) {
        if (frame.contentWindow) frame.contentWindow.postMessage({ name: 'PARENT_READY' }, origin);
      });
    }
    function onMessage(event) {
      if (event.origin !== origin) return;
      var frame = frames.find(function (item) { return item.contentWindow === event.source; });
      if (!frame) return;
      var data = event.data;
      var name = typeof data === 'string' ? data : data && data.name;
      if (name === 'QUANT_REQUEST_READY_STATUS' && script.dataset.ready === 'true') ready();
      if (name === 'RESIZE_HEIGHT') reveal(frame, data.value);
      if (name === 'SCROLL_TO_TESTIMONIALS' || name === 'OPEN_TESTIMONIALS_MODAL') {
        var section = root.querySelector('.fsk-clinician');
        if (!section && root.dataset.fskReviewsTarget) section = document.querySelector(root.dataset.fskReviewsTarget);
        if (section) section.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      }
    }
    function onLoad() {
      // The vendor may finish sizing before a replacement section initializes.
      // Its inline height is distinct from our initial HTML height attribute.
      frames.forEach(function (frame) { reveal(frame, parseFloat(frame.style.height)); });
      if (script.dataset.ready === 'true') ready();
    }
    if (!script) {
      // Load the vendor script for the widget the badge shows (3096 or 18251), so FrontrowMD
      // attributes its views and clicks. The handshake below is the same for both widgets.
      var widget = frames[0].dataset.fskWidget;
      script = document.createElement('script');
      script.src = origin + (widget ? '/api/widgets/script?id=' + widget : '/api/widgets/script?presentation_type=quant&product_id=2584');
      script.defer = true;
      script.dataset.fskQuantLoader = '';
      script.addEventListener('load', function () { script.dataset.ready = 'true'; });
      document.head.appendChild(script);
    }
    window.addEventListener('message', onMessage);
    script.addEventListener('load', ready);
    frames.forEach(function (frame) { frame.addEventListener('load', onLoad); });
    // A badge that loads where its section hides it (the home and kit heroes on desktop) is
    // measured at 0px, and the widget never measures again. Reload it the first time it shows,
    // for example when a tablet rotates to a width where the badge appears.
    var lastHidden = new WeakMap();
    var shown = 'ResizeObserver' in window ? new ResizeObserver(function (entries) {
      entries.forEach(function (entry) {
        var hidden = entry.contentRect.width === 0;
        var wasHidden = lastHidden.get(entry.target);
        lastHidden.set(entry.target, hidden);
        if (!wasHidden || hidden) return;
        var frame = entry.target.querySelector('[data-fsk-badge-frame]');
        if (frame && !(parseFloat(frame.style.height) >= 20)) frame.src = frame.src;
      });
    }) : null;
    // A hidden element gets no first observation, so record where each badge starts.
    if (shown) frames.forEach(function (frame) {
      lastHidden.set(frame.parentElement, frame.parentElement.offsetWidth === 0);
      shown.observe(frame.parentElement);
    });
    onLoad();
    return function () {
      window.removeEventListener('message', onMessage);
      script.removeEventListener('load', ready);
      frames.forEach(function (frame) { frame.removeEventListener('load', onLoad); });
      if (shown) shown.disconnect();
    };
  }

  function initClinicianCarousel(root) {
    var carousel = root.querySelector('[data-fsk-reviews]');
    if (!carousel) return function () {};
    var track = carousel.querySelector('[data-fsk-review-track]');
    var slides = Array.from(carousel.querySelectorAll('[data-fsk-review-slide]'));
    var controls = carousel.querySelector('[data-fsk-review-controls]');
    var prev = carousel.querySelector('[data-fsk-review-prev]');
    var next = carousel.querySelector('[data-fsk-review-next]');
    var counter = carousel.querySelector('[data-fsk-review-counter]');
    if (!track || !slides.length) return function () {};
    var preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    var index = -1;
    var destination = null;
    var width = track.clientWidth;
    var scrollFrame = 0;
    var drag = null;
    function active(value) {
      var nextIndex = Math.max(0, Math.min(slides.length - 1, value));
      if (nextIndex === destination) destination = null;
      if (nextIndex === index) return;
      index = nextIndex;
      slides.forEach(function (slide, i) {
        slide.inert = i !== index;
        slide.setAttribute('aria-hidden', String(i !== index));
      });
      counter.textContent = (index + 1) + ' / ' + slides.length;
    }
    function go(value, instant) {
      var target = ((value % slides.length) + slides.length) % slides.length;
      destination = target;
      track.scrollTo({ left: target * track.clientWidth, behavior: instant || preference.matches ? 'instant' : 'smooth' });
    }
    function onScroll() {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(function () {
        scrollFrame = 0;
        if (track.clientWidth) active(Math.round(track.scrollLeft / track.clientWidth));
      });
    }
    function onPrev() { go((destination === null ? index : destination) - 1); }
    function onNext() { go((destination === null ? index : destination) + 1); }
    function onKey(event) {
      if (event.target !== track) return;
      if (event.key === 'ArrowLeft') onPrev();
      else if (event.key === 'ArrowRight') onNext();
      else if (event.key === 'Home') go(0);
      else if (event.key === 'End') go(slides.length - 1);
      else return;
      event.preventDefault();
    }
    function onDown(event) {
      destination = null;
      if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('a,button')) return;
      drag = { id: event.pointerId, x: event.clientX, left: track.scrollLeft };
      track.setPointerCapture(event.pointerId);
      track.classList.add('is-dragging');
    }
    function onMove(event) {
      if (drag && event.pointerId === drag.id) track.scrollLeft = drag.left - (event.clientX - drag.x);
    }
    function onUp(event) {
      if (!drag || event.pointerId !== drag.id) return;
      var id = drag.id;
      drag = null;
      track.classList.remove('is-dragging');
      if (track.hasPointerCapture(id)) track.releasePointerCapture(id);
      if (track.clientWidth) go(Math.round(track.scrollLeft / track.clientWidth));
    }
    function onResize() {
      if (track.clientWidth && track.clientWidth !== width) {
        width = track.clientWidth;
        go(destination === null ? index : destination, true);
      }
    }
    function onScrollEnd() { destination = null; }
    var observer = 'ResizeObserver' in window ? new ResizeObserver(onResize) : null;
    if (observer) {
      observer.observe(track);
    } else window.addEventListener('resize', onResize);
    track.addEventListener('scroll', onScroll, { passive: true });
    track.addEventListener('scrollend', onScrollEnd);
    track.addEventListener('wheel', onScrollEnd, { passive: true });
    track.addEventListener('keydown', onKey);
    track.addEventListener('pointerdown', onDown);
    track.addEventListener('pointermove', onMove);
    track.addEventListener('pointerup', onUp);
    track.addEventListener('pointercancel', onUp);
    track.addEventListener('lostpointercapture', onUp);
    prev.addEventListener('click', onPrev);
    next.addEventListener('click', onNext);
    controls.hidden = slides.length < 2;
    active(0);
    return function () {
      if (observer) observer.disconnect();
      else window.removeEventListener('resize', onResize);
      window.cancelAnimationFrame(scrollFrame);
      track.removeEventListener('scroll', onScroll);
      track.removeEventListener('scrollend', onScrollEnd);
      track.removeEventListener('wheel', onScrollEnd);
      track.removeEventListener('keydown', onKey);
      track.removeEventListener('pointerdown', onDown);
      track.removeEventListener('pointermove', onMove);
      track.removeEventListener('pointerup', onUp);
      track.removeEventListener('pointercancel', onUp);
      track.removeEventListener('lostpointercapture', onUp);
      prev.removeEventListener('click', onPrev);
      next.removeEventListener('click', onNext);
      if (drag && track.hasPointerCapture(drag.id)) track.releasePointerCapture(drag.id);
      drag = null;
      track.classList.remove('is-dragging');
      slides.forEach(function (slide) { slide.inert = false; slide.removeAttribute('aria-hidden'); });
    };
  }

  // CSS owns the loop; visibility and user preferences decide when it can run.
  function initSynergyMotion(root) {
    var map = root.querySelector('[data-fsk-synergy]');
    if (!map) return function () {};
    var preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    var toggle = map.querySelector('[data-fsk-motion-toggle]');
    if (!('IntersectionObserver' in window)) {
      map.dataset.fskMotion = 'static';
      return function () {};
    }
    var userPaused = false;
    var inView = false;
    var disposed = false;
    function sync() {
      var enabled = !disposed && !preference.matches;
      var playing = enabled && inView && !document.hidden && !userPaused;
      map.classList.toggle('has-motion', enabled);
      map.classList.toggle('is-tracing', playing);
      map.dataset.fskMotion = enabled ? (playing ? 'playing' : 'paused') : 'static';
      if (toggle) {
        toggle.hidden = !enabled;
        toggle.dataset.paused = String(userPaused);
        toggle.setAttribute('aria-label', userPaused ? 'Play animation' : 'Pause animation');
      }
    }
    function onToggle() {
      userPaused = !userPaused;
      sync();
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        inView = entry.isIntersecting && entry.intersectionRatio >= 0.25;
        sync();
      });
    }, { threshold: [0, 0.25], rootMargin: '-80px 0px 0px 0px' });
    observer.observe(map);
    if (toggle) toggle.addEventListener('click', onToggle);
    document.addEventListener('visibilitychange', sync);
    preference.addEventListener('change', sync);
    sync();
    return function () {
      disposed = true;
      observer.disconnect();
      if (toggle) toggle.removeEventListener('click', onToggle);
      document.removeEventListener('visibilitychange', sync);
      preference.removeEventListener('change', sync);
      sync();
    };
  }

  function init(root) {
    if (instances.has(root)) return;
    var hero = root.querySelector('.fsk-hero');
    var close = root.querySelector('.fsk-close');
    var sticky = root.querySelector('[data-fsk-sticky]');
    var hasSticky = Boolean(hero && close && sticky);
    if (!hasSticky && !root.hasAttribute('data-fsk-components')) return;

    if (sticky) sticky.hidden = true;
    var cleanupVideo = initFounderVideo(root);
    var cleanupSynergy = initSynergyMotion(root);
    var cleanupGallery = initGallery(root);
    var cleanupBadges = initClinicianBadges(root);
    var cleanupReviews = initClinicianCarousel(root);
    var cleanupEvaluations = initEvaluations(root);
    // Native lazy loading can stall after an anchor jump in the storefront preview.
    // Promote only nearby images; large photos still wait until their section approaches.
    var imageObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.loading = 'eager';
        imageObserver.unobserve(entry.target);
      });
    }, { rootMargin: '600px 0px' }) : null;
    if (imageObserver) root.querySelectorAll('img[loading="lazy"]').forEach(function (image) { imageObserver.observe(image); });

    function sync() {
      if (!observer) return;
      var heroRect = hero.getBoundingClientRect();
      var closeRect = close.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      var heroPassed = heroRect.bottom <= 0;
      var closeVisible = closeRect.top <= viewportHeight && closeRect.bottom >= 0;
      sticky.hidden = !heroPassed || closeVisible;
    }

    var observer = hasSticky && 'IntersectionObserver' in window ? new IntersectionObserver(sync, { threshold: 0 }) : null;
    if (observer) {
      observer.observe(hero);
      observer.observe(close);
    }
    instances.set(root, {
      sync: sync,
      cleanup: function () {
        if (observer) observer.disconnect();
        if (imageObserver) imageObserver.disconnect();
        cleanupVideo();
        cleanupSynergy();
        cleanupGallery();
        cleanupBadges();
        cleanupReviews();
        cleanupEvaluations();
        if (sticky) sticky.hidden = true;
        instances.delete(root);
      }
    });
    sync();
  }

  function scan(scope) {
    if (scope.matches && scope.matches('[data-fsk], [data-fsk-components]')) init(scope);
    scope.querySelectorAll('[data-fsk], [data-fsk-components]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    popupAttempts.forEach(function (attempt, form) {
      if (event.target === form || event.target.contains(form)) {
        clearPopupAttempt(form);
      }
    });
    instances.forEach(function (instance, root) {
      if (event.target === root || event.target.contains(root)) instance.cleanup();
    });
  });
  window.addEventListener('pageshow', function () {
    instances.forEach(function (instance) { instance.sync(); });
  });
}());
